<script setup lang="ts">
import { tokenService } from '~/api/service/token.service'
import DetailsBox from '~/components/box/DetailsBox.vue'
import TokensTransferTable from '~/components/table/tokens-transfer/TokensTransferTable.vue'
import BcPagination from '~/ui/Pagination/BcPagination.vue'
import { getTokenSeoName } from '~/constants/token.constants'
import { getBreadCrumb } from '~/utils/breadCrumbList'

const route = useRoute()
const address = route.params.address as string
const tokenName = getTokenSeoName(address)
const displayName = tokenName ?? `${address.slice(0, 8)}...${address.slice(-6)}`

useSeoMeta(getMeta(`Token ${displayName}`, `Explore details of Token ${displayName} on MapleStory Universe Explorer`))

const { pagination, rowPerPageList } = usePagination({
  page: 1,
  rowPerPage: 25,
}, false)

const { data, isLoading } = tokenService.useGetTokenTransferList(pagination, address)

useHead(getBreadCrumb())
</script>

<template>
  <DetailsBox>
    Showing all <span class="text-primary">{{ data?.formattedTotalCount }}</span> results
    <template #pagination>
      <BcPagination
        v-model="pagination"
        :row-per-page-list="rowPerPageList"
        :total-count="data?.viewCount"
        hide-rows-per-page
      />
    </template>
  </DetailsBox>
  <Card>
    <TokensTransferTable
      :rows="data?.transferList || []"
      :is-loading="isLoading"
      :row-cnt="pagination.rowPerPage"
    />
    <BcPagination
      v-model="pagination"
      :row-per-page-list="rowPerPageList"
      :total-count="data?.viewCount"
    />
  </Card>
</template>

<style scoped lang="scss">

</style>
